import React, { useState } from 'react';
import PropTypes from 'prop-types';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import {
  Button,
} from 'react-bootstrap5';

import Actions from '../Actions';

export default function Welcome({ nextSlide, closeForm }) {
  const [loading, setLoading] = useState(false);

  const onSkipAllClick = () => {
    setLoading(true);
    Actions.skip('session_feedback', null, () => {
      setLoading(false);
      closeForm();
    });
  };

  return (
    <div style={{ maxWidth: '400px' }}>
      <h2 className="text-center">Please Share Your Feedback!</h2>
      <p className="mt-4">
        Help us improve and keep the quality of each session at the highest
        level. Your comments are private and visible to LeggUP only. We&apos;d be
        so grateful, it will only take a minute.
      </p>
      <div className="text-center mt-4">
        <Button className="col-6 col-md-5" onClick={nextSlide} disabled={loading}>
          Let&apos;s start
        </Button>
        <div className="mt10 mt-3 mb-3 ">or</div>
        <Button className="col-6 col-md-5" variant="outline-primary" onClick={onSkipAllClick} disabled={loading}>
          {loading && <LoadingPlaceholder placement="inline" text=" " />}
          Skip All
        </Button>
      </div>
    </div>
  );
}

Welcome.propTypes = {
  nextSlide: PropTypes.func.isRequired,
  closeForm: PropTypes.func.isRequired,
};
